import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        W marcu 2026 roku Rada Polityki Pieniężnej obniżyła stopy procentowe do 3,75% —
        to kontynuacja cyklu obniżek rozpoczętego w 2025 roku. Dla milionów Polaków ze zmiennym
        oprocentowaniem kredytu oznacza to jedno: raty w końcu zaczynają spadać. Co dokładnie
        się zmieniło i jak to wpływa na Twój kredyt?
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co się zmieniło w marcu 2026?</h2>
      <p>
        RPP obniżyła stopę referencyjną NBP o 0,25 punktu procentowego — z 4,0% do 3,75%.
        To bezpośrednio wpływa na <BlogLink slug="co-to-jest-wibor">WIBOR</BlogLink>, który jest bazą oprocentowania większości kredytów
        hipotecznych w Polsce.
      </p>

      <div className="bg-muted/50 rounded-xl p-4 mt-3">
        <p className="font-semibold mb-2">Aktualne stopy NBP (od marca 2026):</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Stopa referencyjna: <strong>3,75%</strong></li>
          <li>Stopa lombardowa: <strong>4,25%</strong></li>
          <li>Stopa depozytowa: <strong>3,25%</strong></li>
        </ul>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak to wpływa na ratę kredytu?</h2>
      <p>
        Oprocentowanie Twojego kredytu = WIBOR + marża banku. Gdy stopy NBP spadają, WIBOR
        podąża za nimi — ale z opóźnieniem. Jeśli masz WIBOR 6M, zmiana pojawi się przy
        najbliższej aktualizacji (co 6 miesięcy). Przy WIBOR 3M — co 3 miesiące.
      </p>
      <p className="mt-3">
        Przy kredycie na 400 000 zł i spadku WIBOR o 0,25 p.p., rata spada o około
        <strong> 60-70 zł miesięcznie</strong>. To nie rewolucja, ale w skali roku daje
        ponad 700 zł oszczędności. A jeśli stopy spadną dalej — efekt się kumuluje.
      </p>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20} wiborRate={5.0} bankMargin={2.0} section="interest-rate">
          Sprawdź swoją ratę przy aktualnym WIBORze
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co dalej z obniżkami?</h2>
      <p>
        Prognozy analityków wskazują, że stopa referencyjna NBP może spaść do okolic
        <strong> 3,5%</strong> w dalszej części 2026 roku. Tempo obniżek zależy od inflacji
        i sytuacji gospodarczej — RPP podejmuje decyzje indywidualnie na każdym posiedzeniu.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Scenariusz optymistyczny</strong> — stopy spadną do 3,0-3,5%, WIBOR 6M w okolicach 3,5-4,0%, oprocentowanie kredytów 5,5-6,0%</li>
        <li><strong>Scenariusz bazowy</strong> — stopy ustabilizują się na 3,5-3,75%, oprocentowanie 6,0-6,5%</li>
        <li><strong>Scenariusz pesymistyczny</strong> — inflacja wraca, obniżki wstrzymane, oprocentowanie bez zmian</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co to oznacza dla nowych kredytobiorców?</h2>
      <p>
        Spadające stopy to dobra wiadomość — niższe oprocentowanie oznacza wyższą <BlogLink slug="jak-obliczyc-zdolnosc-kredytowa">zdolność kredytową</BlogLink> i niższe raty. Ale uwaga na kilka pułapek:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Ceny mieszkań mogą rosnąć</strong> — niższe stopy = więcej osób stać na kredyt = większy popyt = wyższe ceny</li>
        <li><strong>Nie licz na dalsze spadki</strong> — planuj budżet przy obecnym oprocentowaniu, nie przy prognozowanym</li>
        <li><strong>Rozważ stałe oprocentowanie</strong> — jeśli obecne stawki Ci odpowiadają, stała stopa na 5-7 lat zabezpieczy Cię przed ewentualnymi podwyżkami</li>
        <li><strong>Negocjuj marżę</strong> — to jedyny element oprocentowania, na który masz wpływ. Przy niskim WIBORze marża ma jeszcze większe znaczenie</li>
      </ul>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20} wiborRate={4.0} bankMargin={1.8} section="interest-rate">
          Symuluj ratę przy niższym oprocentowaniu
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">A co z obecnymi kredytobiorcami?</h2>
      <p>
        Jeśli już spłacasz kredyt ze zmiennym oprocentowaniem — cierpliwości. WIBOR aktualizuje
        się z opóźnieniem. Sprawdź w umowie, czy masz WIBOR 3M czy 6M i kiedy przypada
        najbliższa aktualizacja. Po niej powinieneś zobaczyć niższą ratę.
      </p>
      <p className="mt-3">
        To też dobry moment na rozważenie <strong><BlogLink slug="nadplata-kredytu-hipotecznego">nadpłaty kredytu</BlogLink></strong>. Gdy stopy spadają,
        nadpłata jest mniej "urgentna" (odsetki są niższe), ale dalej skraca okres kredytowania
        i obniża całkowity koszt.
      </p>
      <p className="mt-3">
        <strong>Patrz w przyszłość:</strong> do końca 2027 roku WIBOR w Twojej umowie zostanie
        automatycznie zastąpiony przez{' '}
        <BlogLink slug="polstr-zamiast-wibor">POLSTR</BlogLink>{' '}plus spread korygujący.
        Po konwersji rata zacznie aktualizować się co miesiąc — czyli efekty obniżek stóp
        w 2026-2027 odczujesz szybciej niż przy obecnym WIBOR 3M czy 6M.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie</h2>
      <p>
        Obniżka stóp do 3,75% to pozytywny sygnał dla rynku kredytów hipotecznych. Raty
        spadają, zdolność kredytowa rośnie, a prognozy wskazują na dalsze obniżki. Ale nie
        podejmuj decyzji w oparciu o prognozy — sprawdź w kalkulatorze, ile wynosi rata przy
        obecnych stawkach i zaplanuj budżet z zapasem na ewentualne zmiany.
      </p>

      <div className="mt-4">
        <CalculatorLink section="interest-rate">
          Oblicz swoją ratę z aktualnym oprocentowaniem
        </CalculatorLink>
      </div>
    </>
  )
}
